export const NEWSLETTER_GENERIC = {
    logo: require("./resources/images/cbcnewsletter.svg"),
    slogan: "Add some “good” to your morning and evening.",
    desc: "A variety of newsletters you'll love, delivered straight to you.",
    name: "CBC Newsletters",
    success_message: "Thank you for subscribing",
};

export const NEWSLETTERS_LOGO_BASEURL =
    "https://subscriptions.cbc.ca/newsletter_static/images";

export const OPEN_IN_NEW = require("./resources/images/open-in-new.svg");
